import React from "react";
import css from "./card_.module.scss";
import CreditHistoryTable from "components/Header/CreditHistory/CreditHistoryTable";
import {
  Modal,
  Box,
  Typography,
  LinearProgress,
  Grid,
  IconButton,
} from "@mui/material";
import { Gauge } from "@mui/x-charts/Gauge";
import CloseIcon from "@mui/icons-material/Close";
import GaugeComponent from "react-gauge-component";
import Chip from "@mui/material/Chip";
function InfoCard({
  title,
  icon,
  value,
  color = "white",
  button,
  userDetails,
  userProgress,
  levelColor
}) {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "52vW",
    height: "88vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    borderRadius: "20px",
  };

  const credits = userDetails?.credits || 0;

  const CoursePLE =
    (userProgress?.course?.completed / userProgress?.course?.total) * 100 || 0;

  const AssessmentPLE =
    (userProgress?.assessment?.completed / userProgress?.assessment?.total) *
      100 || 0;

  let percent = 0;

  if (credits >= 0 && credits < 400) {
    percent = ((credits - 1) / (400 - 1)) * 0.25; // Map to 0% - 25%
  } else if (credits >= 400 && credits < 1000) {
    percent = 0.25 + ((credits - 400) / (1000 - 400)) * 0.25; // Map to 25% - 50%
  } else if (credits >= 1000 && credits < 2500) {
    percent = 0.5 + ((credits - 1000) / (2500 - 1000)) * 0.25; // Map to 50% - 75%
  } else if (credits >= 2500) {
    percent = 0.75 + ((credits - 2500) / (5000 - 2500)) * 0.25; // Map to 75% - 100%
  }

  // Ensure percent stays within 0-1
  percent = Math.min(Math.max(percent, 0), 1);

  return (
    <div className={css.card_wrap} style={{ backgroundColor: color }}>
      <div className={css.header}>
        <h1 className={css.title}>{title}</h1>

        {button && (
          <div className={css.button_wrap} onClick={handleOpen}>
            {button}
          </div>
        )}
      </div>
      <div className={css.value_wrap}>
        {icon}
        {value}
      </div>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className={css.ModalPLE}
          sx={style}
          style={{ position: "relative" }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>
          <div
            className={css.MainWrapper}
            container
            spacing={2}
            style={{ marginBottom: "20px", padding: "20px" }}
          >
            <div className={css.guageSection}>
              <div className={css.gauge} textAlign="center">
                <GaugeComponent
                  type="semicircle"
                  nrOfLevels={4}
                  arc={{
                    colorArray: ["#FF2121", "#FF8C00", "#FFFF00", "#00FF15"], // 4 Distinct Colors
                    padding: 0.01,
                    subArcs: [
                      { limit: 25 }, // Rookie (0 - 400)
                      { limit: 50 }, // Beginner (400 - 1000)
                      { limit: 75 }, // Intermediate (1000 - 2500)
                      { limit: 100 }, // Advanced (2500+)
                    ],
                  }}
                  arcWidth={0.01}
                  value={percent * 100} // Moves the blob dynamically
                  pointer={{
                    type: "blob", // Blob instead of needle
                    animationDelay: 0,
                  }}
                  labels={{
                    valueLabel: {
                      hide: true, // Hides the center value label
                    },
                  }}
                />

                <div className={css.pleScoreWrap}>
                  <h1>{credits}</h1>
                  <h5>PLE SCORE</h5>
                  <Chip
                    label={userDetails?.level}
                    sx={{
                      backgroundColor: levelColor,
                      color: "white",
                      height: "25px",
                    }}
                  />
                </div>
              </div>

              <div className={css.LinearProgress} item xs={12} md={7}>
                <Typography
                  variant="body1"
                  style={{ marginBottom: "5px", fontWeight: "bold" }}
                >
                  Credits Earned:
                </Typography>
                <Typography variant="body1" style={{ marginBottom: "5px" }}>
                  Courses: {userProgress?.course?.completed}
                </Typography>
                <LinearProgress
                  variant="determinate"
                  value={CoursePLE}
                  style={{ marginBottom: "5px" }}
                  sx={{
                    height: 10, // Adjust height
                    borderRadius: 50, // Make ends rounded (you can adjust the value)
                    "& .MuiLinearProgress-bar": {
                      borderRadius: "50px", // Make the bar's ends rounded
                    },
                  }}
                />
                <Typography variant="body1" style={{ marginBottom: "5px" }}>
                  Assessment: {userProgress?.assessment?.completed}
                </Typography>
                <LinearProgress
                  variant="determinate"
                  value={AssessmentPLE}
                  style={{ marginBottom: "5px" }}
                  sx={{
                    height: 10, // Adjust height
                    borderRadius: 50, // Make ends rounded (you can adjust the value)
                    "& .MuiLinearProgress-bar": {
                      borderRadius: "50px", // Make the bar's ends rounded
                    },
                  }}
                />
                <Typography variant="body1" style={{ marginBottom: "5px" }}>
                  Asked the Mentor: 70
                </Typography>
                <LinearProgress
                  variant="determinate"
                  value={70}
                  style={{ marginBottom: "5px" }}
                  sx={{
                    height: 10, // Adjust height
                    borderRadius: 50, // Make ends rounded (you can adjust the value)
                    "& .MuiLinearProgress-bar": {
                      borderRadius: "50px",
                    },
                  }}
                />
              </div>
            </div>
            <h5 style={{ marginLeft: "16px" }}>PLE Credits History</h5>
            <CreditHistoryTable />
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default InfoCard;
